import { Component, OnInit } from '@angular/core';
import { TcPage, IPageState } from '@tc/core';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-commercial-imputations-page',
  templateUrl: './commercial-imputations-page.component.html',
  styleUrls: ['./commercial-imputations-page.component.scss']
})
export class CommercialImputationsPageComponent extends TcPage implements OnInit {

  constructor(
    store: Store<any>) {
    super(store);
  }

  ngOnInit() {
    const pageInfo: IPageState = {
      title: 'commercial-imputations-page.title'
    };

    this.pageInfo = pageInfo;

    super.ngOnInit();
  }
}
